module.exports = __webpack_public_path__ + "static/img/20019 (5).c27afd1.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20019 (5).webp
// module id = +NOv
// module chunks = 14